module.exports = __webpack_public_path__ + "static/media/YF75_05.0fc11205.jpg";